import { filter } from 'lodash'
import type { FieldSpec } from '@wix/wix-data-schema-types'
import { FieldType } from '@wix/wix-data-schema-types'

export const countConnectedDynamicPages = ({
  fields = {},
}: {
  fields: {
    [fieldName: string]: FieldSpec
  }
}) => filter(fields, { type: FieldType.pageLink }).length
